import React from 'react';

export const SplashLayout: React.FC<React.PropsWithChildren> = ({
  children,
}) => (
  <div className="splash-layout">
    <main className="splash-layout__children">{children}</main>
  </div>
);
